import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { InfluencersContainer } from "./InfluencersStyled";
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../context/userContext";

import back from './../../utils/images/arrow_back.svg';
import dropDownPink from './../../utils/images/arrow_down_pink.svg';
import dropDownPinkUp from './../../utils/images/arrow_down_pink_up.svg';

//import arrowPink from './../../utils/images/arrow_down_pink.svg';

import { getAllInfluencers, getAllInfluencersFilter, getFeaturedInfluencers, getInfluencersByRate, getNewInfluencers } from "../../api/influencerApi";
import InfluencerCard from './../../components/InfluencerCard/InfluencerCar';
import Spinner from './../../components/Spinner/Spinner';
import { LangContext } from "../../context/langContext";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { useRef } from "react";
import { FiltersContext } from "../../context/filtersContext";
import { getAgeRange, getCategories, getCountries, getLanguages, getNetworks, getPriceRange } from "../../api/filtersApi";


export default function Influencers() {

    const orderByRef = useRef(null);

    const { companyId, userToken } = useContext(UserContext);
    const { locale } = useContext(LangContext);
    const { featuredFilter, setFeaturedFilter, setNewUserFilter, newUserFilter, languageFilter, setLanguageFilter, ratingFilter, setRatingFilter, verifiedFilter, setVerifiedFilter, genderFilter, setGenderFilter, ageFilter, setAgeFilter, networkFilter, setNetworkFilter, categoryFilter, setCategoryFilter, countryFilter, setCountryFilter, priceFilter, setPriceFilter, queryPrice, setQueryPrice, queryPriceId, setQueryPriceId, inputFilter, orderBy, setOrderBy } = useContext(FiltersContext);

    const [influencers, setInfluencers] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [limit, setLimit] = useState(12);
    const [offset, setOffset] = useState(0);

    const [total, setTotal] = useState(0);

    const [showFilterBy, setShowFilterBy] = useState(false);
    const [showFilterByLanguage, setShowFilterByLanguage] = useState(false);
    const [showFilterByVerified, setShowFilterByVerified] = useState(false);
    const [showFilterByGender, setShowFilterByGender] = useState(false);
    const [showFilterByAge, setShowFilterByAge] = useState(false);
    const [showFilterByNetwork, setShowFilterByNetwork] = useState(false);
    const [showFilterByCountries, setShowFilterByCountries] = useState(false);
    const [showFilterByCategories, setShowFilterByCategories] = useState(false);
    const [showFilterByPrices, setShowFilterByPrices] = useState(false);

    const [showFilterByFollowers, setShowFilterByFollowers] = useState(false);
    const [showFilterByCollaborations, setShowFilterByCollaborations] = useState(false);

    const [showOrderByMenu, setShowOrderByMenu] = useState(false);

    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [ageOptions, setAgeOptions] = useState([]);
    const [networksOptions, setNetworksOptions] = useState([]);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [pricesOptions, setPricesOptions] = useState([]);


    const seeMore = () => {
        setOffset(offset + limit);
    }

    /**------Vendrá de back------- */
    const followerOptions = [{ nombre: '1m+', name: '1m+' }, { nombre: '500k+', name: '500k+' }, { nombre: '100k+', name: '100k+' }, { nombre: '10k+', name: '10k+' }, { nombre: 'menos 10k', name: 'less 10k' }]

    const collaborationsOptions = [{ nombre: '0 - 24', name: '0 - 24' }, { nombre: '25 - 49', name: '25 - 49' }, { nombre: '50 - 99', name: '50 - 99' }, { nombre: '100+', name: '100+' }]

    useEffect(() => {
        getLanguages().then((response) => {
            setLanguagesOptions(response);
        })
        getAgeRange().then((response) => {
            setAgeOptions(response);
        })
        getNetworks().then((response) => {
            setNetworksOptions(response);
        })
        getCategories().then((response) => {
            setCategoriesOptions(response);
        })
        getCountries().then((response) => {
            setCountriesOptions(response);
        })
        getPriceRange().then((response) => {
            setPricesOptions(response);
        })
    }, [])

    const handlerLanguageFilter = (event, language) => {

        const auxLanguageFilter = [...languageFilter];
        if (event.target.checked) {
            auxLanguageFilter.push(language.id);
            setLanguageFilter(auxLanguageFilter);
            setOffset(0);
        } else {
            const newLanguage = auxLanguageFilter.filter(lang => lang !== language.id);
            setLanguageFilter(newLanguage);
            setOffset(0);
        }
    }

    const handlerVerifiedFilter = (event, verified) => {
        const auxVerifiedFilter = [...verifiedFilter];
        if (event.target.checked) {
            auxVerifiedFilter.push(verified);
            setVerifiedFilter(auxVerifiedFilter);
            setOffset(0);
        } else {
            const verifiedStatus = auxVerifiedFilter.filter(lang => lang !== verified);
            setVerifiedFilter(verifiedStatus);
            setOffset(0);
        }
    }

    const handlerGenderFilter = (event, gender) => {
        const auxGenderFilter = [...genderFilter];
        if (event.target.checked) {
            auxGenderFilter.push(gender);
            setGenderFilter(auxGenderFilter);
            setOffset(0);
        } else {
            const newGender = auxGenderFilter.filter(gen => gen !== gender);
            setGenderFilter(newGender);
            setOffset(0);
        }
    }

    const handlerAgeFilter = (event, age) => {
        const auxAgeFilter = [...ageFilter];
        if (event.target.checked) {
            auxAgeFilter.push(age);
            setAgeFilter(auxAgeFilter);
            setOffset(0);
        } else {
            const newAge = auxAgeFilter.filter(ageRange => ageRange !== age);
            setAgeFilter(newAge);
            setOffset(0);
        }
    }

    const handlerNetworkFilter = (event, network) => {

        const auxNetworkFilter = [...networkFilter];
        if (event.target.checked) {
            auxNetworkFilter.push(network);
            setNetworkFilter(auxNetworkFilter);
            setOffset(0);
        } else {
            const newNetwork = auxNetworkFilter.filter(net => net !== network);
            setNetworkFilter(newNetwork);
            setOffset(0);
        }
    }

    const handlerCountryFilter = (event, country) => {
        const auxCountryFilter = [...countryFilter];
        if (event.target.checked) {
            auxCountryFilter.push(country);
            setCountryFilter(auxCountryFilter);
            setOffset(0);
        } else {
            const newCountry = auxCountryFilter.filter(count => count !== country);
            setCountryFilter(newCountry);
            setOffset(0);
        }
    }

    const handlerCategoryFilter = (event, category) => {
        const auxCategoryFilter = [...categoryFilter];
        if (event.target.checked) {
            auxCategoryFilter.push(category);
            setCategoryFilter(auxCategoryFilter);
            setOffset(0);
        } else {
            const newCategory = auxCategoryFilter.filter(cat => cat !== category);
            setCategoryFilter(newCategory);
            setOffset(0);
        }
    }

    const handlerPriceFilter = (event, price) => {

        if (event.target.checked) {
            switch (price.id) {
                case (1):
                    setQueryPrice([...queryPrice, 'and(rate.lt.10)'])
                    setQueryPriceId([...queryPriceId, 1])
                    break;
                case (2):
                    setQueryPrice([...queryPrice, 'and(rate.gte.10,rate.lte.24)'])
                    setQueryPriceId([...queryPriceId, 2])
                    break;
                case (3):
                    setQueryPrice([...queryPrice, 'and(rate.gte.25,rate.lte.49)'])
                    setQueryPriceId([...queryPriceId, 3])
                    break;
                case (4):
                    setQueryPrice([...queryPrice, 'and(rate.gte.50,rate.lte.99)'])
                    setQueryPriceId([...queryPriceId, 4])
                    break;
                default:
                    setQueryPrice([...queryPrice, 'and(rate.gte.100)'])
                    setQueryPriceId([...queryPriceId, 5])
            }

        } else {
            switch (price.id) {
                case (1):
                    queryPrice.splice(queryPrice.indexOf('and(rate.lt.10)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(1), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (2):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.10,rate.lte.24)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(2), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (3):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.25,rate.lte.49)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(3), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (4):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.50,rate.lte.99)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(4), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                default:
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.100)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(5), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
            }
        }
    }

    useEffect(() => {
        let influencersId = []

        if (queryPrice.length > 0) {
            getInfluencersByRate({ query: queryPrice.toString() }).then((response) => {
                response.map((influencer) => {
                    influencersId.push(influencer.influincr)
                })

                const auxPriceFilter = new Set(influencersId)
                let result = [...auxPriceFilter]

                setPriceFilter(result);
                setOffset(0);
            })
        } else {
            setPriceFilter([]);
            setOffset(0);
        }
    }, [queryPrice])

    const handlerOrderBy = (event, category) => {
        setOrderBy(event.target.value)
        setOffset(0);
    }

    useEffect(() => {

        let query = '';
        if (featuredFilter) {
            query = query + '&featured=eq.true'
        }
        if (newUserFilter) {
            query = query + '&newuser=eq.true'
        }
        if (languageFilter.length > 0) {
            const iniQuery = []
            languageFilter.map((languageId) => {
                iniQuery.push(`languageid.like.%${languageId}%`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }
        if (ratingFilter !== null) {
            query = query + `&rating=gte.${ratingFilter}`
        }
        if (verifiedFilter.length > 0) {
            verifiedFilter.map((verified) => {
                if (verified === 'yes') {
                    query = query + '&attributes->>verified=eq.true'
                } else {
                    query = query + '&attributes->>verified=eq.false'
                }
            })
        }
        if (genderFilter.length > 0) {
            genderFilter.map((gender) => {
                if (gender === 'female') {
                    query = query + '&or=(gender.ilike.femenino, gender.ilike.female)'
                } else if (gender === 'male') {
                    query = query + '&or=(gender.ilike.masculino, gender.ilike.male)'
                } else {
                    query = query + '&and=(gender.neq.masculino, gender.neq.male,gender.neq.femenino, gender.neq.female,gender.neq.Masculino, gender.neq.Male,gender.neq.Femenino, gender.neq.Female)'
                }
            })
        }

        if (ageFilter.length > 0) {

            const today = new Date();

            const twenty = `${(today.getFullYear() - 20)}-${today.getMonth() + 1}-${today.getDate()}`
            const twentynine = `${(today.getFullYear() - 29)}-${today.getMonth() + 1}-${today.getDate()}`
            const thirty = `${(today.getFullYear() - 30)}-${today.getMonth() + 1}-${today.getDate()}`
            const thirtynine = `${(today.getFullYear() - 39)}-${today.getMonth() + 1}-${today.getDate()}`
            const fourty = `${(today.getFullYear() - 40)}-${today.getMonth() + 1}-${today.getDate()}`
            const fourtynine = `${(today.getFullYear() - 49)}-${today.getMonth() + 1}-${today.getDate()}`
            const fifty = `${(today.getFullYear() - 50)}-${today.getMonth() + 1}-${today.getDate()}`
            ageFilter.map((age) => {
                if (age === '-20') {
                    query = query + `&birthday=gte.${twenty}`
                } else if (age === '20-29') {
                    query = query + `&and=(birthday.gte.${twentynine}, birthday.lte.${twenty})`
                } else if (age === '30-39') {
                    query = query + `&and=(birthday.gte.${thirtynine}, birthday.lte.${thirty})`
                } else if (age === '40-49') {
                    query = query + `&and=(birthday.gte.${fourtynine}, birthday.lte.${fourty})`
                } else {
                    query = query + `&birthday=lte.${fifty}`
                }
            })
        }
        if (networkFilter.length > 0) {
            const iniQuery = []
            networkFilter.map((network) => {
                iniQuery.push(`idsocialnetwork->>${network.toLowerCase()}.not.eq.null`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }
        if (categoryFilter.length > 0) {
            const iniQuery = []
            categoryFilter.map((categoryId) => {
                iniQuery.push(`categoryid.fts.${categoryId}`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }

        if (countryFilter.length > 0) {
            const iniQuery = []
            countryFilter.map((countryId) => {
                iniQuery.push(`country.eq.${countryId}`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }

        if (priceFilter.length > 0) {
            query = query + `&id=in.(${priceFilter.toString()})`
        }

        if (inputFilter.length > 0) {
            query = query + `&or=(givenname.ilike.*${inputFilter}*,familyname.ilike.*${inputFilter}*,name.ilike.*${inputFilter}*,username.ilike.*${inputFilter}*,city.ilike.*${inputFilter}*)`
        }

        if (orderBy.length > 0) {
            if (orderBy === 'name') {
                query = query + `&order=givenname.asc`
            } else if (orderBy === 'lowerRange') {
                query = query + `&order=rating.asc`
            } else {
                query = query + `&order=rating.desc`
            }
        }

        if (offset > 0) {
            getAllInfluencersFilter({ companyId: companyId, query: query, limit: limit, offset: offset }).then(({ data, pagination }) => {
                const auxInfluencer = influencers.concat(data);
                setInfluencers(auxInfluencer);
                setIsLoading(false);
                setTotal(pagination.split('/')[1]);
            })
        }

    }, [offset])


    useEffect(() => {

        let query = '';
        if (featuredFilter) {
            query = query + '&featured=eq.true'
        }
        if (newUserFilter) {
            query = query + '&newuser=eq.true'
        }
        if (languageFilter.length > 0) {
            const iniQuery = []
            languageFilter.map((languageId) => {
                //query = query + `&languageid=like.%${languageId}%`
                iniQuery.push(`languageid.like.%${languageId}%`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }
        if (ratingFilter !== null) {
            query = query + `&rating=gte.${ratingFilter}`
        }
        if (verifiedFilter.length > 0) {
            verifiedFilter.map((verified) => {
                if (verified === 'yes') {
                    query = query + '&attributes->>verified=eq.true'
                } else {
                    query = query + '&attributes->>verified=eq.false'
                }
            })
        }
        if (genderFilter.length > 0) {
            genderFilter.map((gender) => {
                if (gender === 'female') {
                    query = query + '&or=(gender.ilike.femenino, gender.ilike.female)'
                } else if (gender === 'male') {
                    query = query + '&or=(gender.ilike.masculino, gender.ilike.male)'
                } else {
                    query = query + '&and=(gender.neq.masculino, gender.neq.male,gender.neq.femenino, gender.neq.female,gender.neq.Masculino, gender.neq.Male,gender.neq.Femenino, gender.neq.Female)'
                }
            })
        }


        if (ageFilter.length > 0) {

            const today = new Date();

            const twenty = `${(today.getFullYear() - 20)}-${today.getMonth() + 1}-${today.getDate()}`
            const twentynine = `${(today.getFullYear() - 29)}-${today.getMonth() + 1}-${today.getDate()}`
            const thirty = `${(today.getFullYear() - 30)}-${today.getMonth() + 1}-${today.getDate()}`
            const thirtynine = `${(today.getFullYear() - 39)}-${today.getMonth() + 1}-${today.getDate()}`
            const fourty = `${(today.getFullYear() - 40)}-${today.getMonth() + 1}-${today.getDate()}`
            const fourtynine = `${(today.getFullYear() - 49)}-${today.getMonth() + 1}-${today.getDate()}`
            const fifty = `${(today.getFullYear() - 50)}-${today.getMonth() + 1}-${today.getDate()}`
            ageFilter.map((age) => {
                if (age === '-20') {
                    query = query + `&birthday=gte.${twenty}`
                } else if (age === '20-29') {
                    query = query + `&and=(birthday.gte.${twentynine}, birthday.lte.${twenty})`
                } else if (age === '30-39') {
                    query = query + `&and=(birthday.gte.${thirtynine}, birthday.lte.${thirty})`
                } else if (age === '40-49') {
                    query = query + `&and=(birthday.gte.${fourtynine}, birthday.lte.${fourty})`
                } else {
                    query = query + `&birthday=lte.${fifty}`
                }
            })
        }
        if (networkFilter.length > 0) {
            const iniQuery = []
            networkFilter.map((network) => {
                iniQuery.push(`idsocialnetwork->>${network.toLowerCase()}.not.eq.null`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }
        if (categoryFilter.length > 0) {
            const iniQuery = []
            categoryFilter.map((categoryId) => {
                //query = query + `&categoryid=eq.${categoryId}`
                //iniQuery.push(`categoryid.eq.${categoryId}`)
                //iniQuery.push(`categoryid.like.%${categoryId}%`)
                iniQuery.push(`categoryid.fts.${categoryId}`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }

        if (countryFilter.length > 0) {
            const iniQuery = []
            countryFilter.map((countryId) => {
                iniQuery.push(`country.eq.${countryId}`)
            })
            query = query + `&or=(${iniQuery.toString()})`
        }

        if (priceFilter.length > 0) {
            query = query + `&id=in.(${priceFilter.toString()})`
        }

        if (inputFilter.length > 0) {
            query = query + `&or=(givenname.ilike.*${inputFilter}*,familyname.ilike.*${inputFilter}*,name.ilike.*${inputFilter}*,username.ilike.*${inputFilter}*,city.ilike.*${inputFilter}*)`
        }

        if (orderBy.length > 0) {
            if (orderBy === 'name') {
                query = query + `&order=givenname.asc`
            } else if (orderBy === 'lowerRange') {
                query = query + `&order=rating.asc`
            } else {
                query = query + `&order=rating.desc`
            }
        }

        setIsLoading(true);
        getAllInfluencersFilter({ companyId: companyId, query: query, limit: 12, offset: 0 }).then(({ data, pagination }) => {
            setInfluencers(data);
            setIsLoading(false);
            setTotal(pagination.split('/')[1]);
            setLimit(12);
            setOffset(0);
        })

    }, [newUserFilter, featuredFilter, languageFilter, ratingFilter, verifiedFilter, genderFilter, ageFilter, categoryFilter, countryFilter, priceFilter, inputFilter, orderBy])


    useEffect(() => {

        function handleClickOutside(event) {
            if (orderByRef.current && !orderByRef.current.contains(event.target)) {
                setShowOrderByMenu(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [orderByRef])

    return (
        <InfluencersContainer>
            {/* <div className="goBack" onClick={() => navigate(-1)}>
                <img src={back} alt="go back" className="backIcon" />
                <p>
                    <FormattedMessage id="go_back" defaultMessage="ir atrás" />
                </p>
            </div> */}
            <div className="influencersBody">
                <div className="menu">

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_1_subtitle_6" defaultMessage="Idioma" /></span>
                            <img src={(showFilterByLanguage) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByLanguage(!showFilterByLanguage) }} />
                        </div>
                        {(showFilterByLanguage) && (<div className="options">

                            {languagesOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} onChange={(event) => { handlerLanguageFilter(event, language) }} checked={languageFilter.includes(language.id)} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                        </div>)}
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_1_subtitle_7" defaultMessage="Verificado" /></span>
                            <img src={(showFilterByVerified) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByVerified(!showFilterByVerified) }} />
                        </div>
                        {(showFilterByVerified) && (<div className="options">

                            <label htmlFor='yes' className='option'> <input type="checkbox" id='yes' name="verified" value='yes' checked={verifiedFilter.includes('yes')} onChange={(event) => {
                                handlerVerifiedFilter(event, 'yes')
                            }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_1" defaultMessage="Si" /></label>

                            <label htmlFor='no' className='option'> <input type="checkbox" id='no' name="verified" value='no' checked={verifiedFilter.includes('no')} onChange={(event) => { handlerVerifiedFilter(event, 'no') }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_2" defaultMessage="No" /></label>

                        </div>)}
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_1_subtitle_5" defaultMessage="Género" /></span>
                            <img src={(showFilterByGender) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByGender(!showFilterByGender) }} />
                        </div>
                        {(showFilterByGender) && (<div className="options">

                            <label htmlFor='female' className='option'> <input type="checkbox" id='female' name="gender" value='female' checked={genderFilter.includes('female')} onChange={(event) => { handlerGenderFilter(event, 'female') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_1" defaultMessage="Femenino" /></label>

                            <label htmlFor='male' className='option'> <input type="checkbox" id='male' name="gender" value='male' checked={genderFilter.includes('male')} onChange={(event) => { handlerGenderFilter(event, 'male') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_2" defaultMessage="Masculino" /></label>

                            <label htmlFor='other' className='option'> <input type="checkbox" id='other' name="gender" value='other' checked={genderFilter.includes('other')} onChange={(event) => { handlerGenderFilter(event, 'other') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_3" defaultMessage="Otro" /></label>
                        </div>)}
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_1_subtitle_4" defaultMessage="Edad" /></span>
                            <img src={(showFilterByAge) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByAge(!showFilterByAge) }} />
                        </div>
                        {(showFilterByAge) && (<div className="options">

                            {ageOptions.map((age) => (<label htmlFor={age.range} className='option'> <input type="checkbox" id={age.range} name="age" value={age.range} checked={ageFilter.includes(age.range)} onChange={(event) => { handlerAgeFilter(event, age.range) }} /> {age.range}</label>))}

                        </div>)}
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_1_subtitle_8" defaultMessage="Redes sociales" /></span>
                            <img src={(showFilterByNetwork) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByNetwork(!showFilterByNetwork) }} />
                        </div>
                        {(showFilterByNetwork) && (<div className="options">

                            {networksOptions.map((network) => (<label htmlFor={network.name} className='option'> <input type="checkbox" id={network.name} name="age" value={network.name} checked={networkFilter.includes(network.name)} onChange={(event) => { handlerNetworkFilter(event, network.name) }} /> {network.name}</label>))}

                        </div>)}
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_3" defaultMessage="País" /></span>
                            <img src={(showFilterByCountries) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCountries(!showFilterByCountries) }} />
                        </div>

                        {(showFilterByCountries) && (
                            <div className="options">
                                {countriesOptions.map((country) => (<label htmlFor={country.name} className='option'> <input type="checkbox" id={country.name} name="category" value={country.name} checked={countryFilter.includes(country.id)} onChange={(event) => { handlerCountryFilter(event, country.id) }} /> {(locale === 'es-CO') ? country.nombre : country.name}</label>))}

                            </div>
                        )}
                    </div>

                    <div className="filter" >
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_2" defaultMessage="Categoría" /></span>
                            <img src={(showFilterByCategories) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCategories(!showFilterByCategories) }} />
                        </div>

                        {(showFilterByCategories) && (

                            <div className="options">

                                {categoriesOptions.map((category) => (<label htmlFor={category.name} className='option'> <input type="checkbox" id={category.name} name="category" value={category.name} checked={categoryFilter.includes(category.id)} onChange={(event) => { handlerCategoryFilter(event, category.id) }} /> {(locale === 'es-CO') ? category.nombre : category.name}</label>))}

                            </div>)}
                    </div>

                    <div className="filter" >
                        <div className="filterName">
                            <span><FormattedMessage id="filter_title_4" defaultMessage="Precio" /></span>
                            <img src={(showFilterByPrices) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByPrices(!showFilterByPrices) }} />
                        </div>

                        {(showFilterByPrices) && (

                            <div className="options">

                                {pricesOptions.map((price) => (<label htmlFor={price.range} className='option'> <input type="checkbox" id={price.range} name="category" value={price.range} checked={queryPriceId.includes(price.id)} onChange={(event) => { handlerPriceFilter(event, price) }} /> {(locale === 'es-CO') ? price.rango : price.range}</label>))}

                            </div>)}
                    </div>

                    {/* <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_2" defaultMessage="# de seguidores" /></span>
                            <img src={(showFilterByFollowers) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByFollowers(!showFilterByFollowers) }} />
                        </div>
                        {(showFilterByFollowers) && (<div className="options">

                            {followerOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                        </div>)}
                    </div> */}

                    {/* <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_3" defaultMessage="# de colaboraciones" /></span>
                            <img src={(showFilterByCollaborations) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCollaborations(!showFilterByCollaborations) }} />
                        </div>
                        {(showFilterByCollaborations) && (<div className="options">

                            {collaborationsOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                        </div>)}
                    </div> */}

                    <div className="filter">
                        <div className="filterName">
                            <p><FormattedMessage id="companies_menu_option_8" defaultMessage="Rango" /></p>
                        </div>
                        <Stack spacing={1}>
                            <Rating style={{ color: '#E8339E' }} name="size-large" /* defaultValue={2} */ size="large" precision={0.5} value={ratingFilter} onChange={(event, newValue) => {
                                setRatingFilter(newValue);
                                setOffset(0);
                            }}
                            />
                        </Stack>
                    </div>


                    <div className="filter">
                        <div className="filterName">
                            <span onClick={() => {
                                setFeaturedFilter(!featuredFilter)
                                setOffset(0);
                            }} className={featuredFilter && 'selected'}><FormattedMessage id="companies_menu_option_4" defaultMessage="Destacados" /></span>

                        </div>
                    </div>

                    <div className="filter">
                        <div className="filterName">
                            <span onClick={() => {
                                setNewUserFilter(!newUserFilter)
                                setOffset(0);
                            }} className={newUserFilter && 'selected'} ><FormattedMessage id="companies_menu_option_5" defaultMessage="Nuevos" /></span>

                        </div>
                    </div>

                    {/*  <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_6" defaultMessage="Mis favoritos" /></span>

                        </div>
                    </div> */}

                    {/*  <div className="filter">
                        <div className="filterName">
                            <span><FormattedMessage id="companies_menu_option_7" defaultMessage="Mis me gusta" /></span>

                        </div>
                    </div> */}

                </div>

                <div className="menuMobile">
                    <div className="filterTitle">
                        <p><FormattedMessage id="filter_title_1" defaultMessage="Filtrar por" />
                        </p>
                        <img src={(showFilterBy) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterBy(!showFilterBy) }} />
                    </div>

                    {(showFilterBy) && (
                        <div className="subFilter" >

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_1_subtitle_6" defaultMessage="Idioma" /></span>
                                    <img src={(showFilterByLanguage) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByLanguage(!showFilterByLanguage) }} />
                                </div>
                                {(showFilterByLanguage) && (<div className="options">

                                    {languagesOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} onChange={(event) => { handlerLanguageFilter(event, language) }} checked={languageFilter.includes(language.id)} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                                </div>)}
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_1_subtitle_7" defaultMessage="Verificado" /></span>
                                    <img src={(showFilterByVerified) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByVerified(!showFilterByVerified) }} />
                                </div>
                                {(showFilterByVerified) && (<div className="options">

                                    <label htmlFor='yes' className='option'> <input type="checkbox" id='yes' name="verified" value='yes' checked={verifiedFilter.includes('yes')} onChange={(event) => {
                                        handlerVerifiedFilter(event, 'yes')
                                    }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_1" defaultMessage="Si" /></label>

                                    <label htmlFor='no' className='option'> <input type="checkbox" id='no' name="verified" value='no' checked={verifiedFilter.includes('no')} onChange={(event) => { handlerVerifiedFilter(event, 'no') }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_2" defaultMessage="No" /></label>

                                </div>)}
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_1_subtitle_5" defaultMessage="Género" /></span>
                                    <img src={(showFilterByGender) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByGender(!showFilterByGender) }} />
                                </div>
                                {(showFilterByGender) && (<div className="options">

                                    <label htmlFor='female' className='option'> <input type="checkbox" id='female' name="gender" value='female' checked={genderFilter.includes('female')} onChange={(event) => { handlerGenderFilter(event, 'female') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_1" defaultMessage="Femenino" /></label>

                                    <label htmlFor='male' className='option'> <input type="checkbox" id='male' name="gender" value='male' checked={genderFilter.includes('male')} onChange={(event) => { handlerGenderFilter(event, 'male') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_2" defaultMessage="Masculino" /></label>

                                    <label htmlFor='other' className='option'> <input type="checkbox" id='other' name="gender" value='other' checked={genderFilter.includes('other')} onChange={(event) => { handlerGenderFilter(event, 'other') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_3" defaultMessage="Otro" /></label>
                                </div>)}
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_1_subtitle_4" defaultMessage="Edad" /></span>
                                    <img src={(showFilterByAge) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByAge(!showFilterByAge) }} />
                                </div>
                                {(showFilterByAge) && (<div className="options">

                                    {ageOptions.map((age) => (<label htmlFor={age.range} className='option'> <input type="checkbox" id={age.range} name="age" value={age.range} checked={ageFilter.includes(age.range)} onChange={(event) => { handlerAgeFilter(event, age.range) }} /> {age.range}</label>))}

                                </div>)}
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_1_subtitle_8" defaultMessage="Redes sociales" /></span>
                                    <img src={(showFilterByNetwork) ? dropDownPinkUp : dropDownPink} alt="down" className="down" onClick={() => { setShowFilterByNetwork(!showFilterByNetwork) }} />
                                </div>
                                {(showFilterByNetwork) && (<div className="options">

                                    {networksOptions.map((network) => (<label htmlFor={network.name} className='option'> <input type="checkbox" id={network.name} name="age" value={network.name} checked={networkFilter.includes(network.name)} onChange={(event) => { handlerNetworkFilter(event, network.name) }} /> {network.name}</label>))}

                                </div>)}
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_3" defaultMessage="País" /></span>
                                    <img src={(showFilterByCountries) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCountries(!showFilterByCountries) }} />
                                </div>

                                {(showFilterByCountries) && (
                                    <div className="options">
                                        {countriesOptions.map((country) => (<label htmlFor={country.name} className='option'> <input type="checkbox" id={country.name} name="category" value={country.name} checked={countryFilter.includes(country.id)} onChange={(event) => { handlerCountryFilter(event, country.id) }} /> {(locale === 'es-CO') ? country.nombre : country.name}</label>))}

                                    </div>
                                )}
                            </div>

                            <div className="filter" >
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_2" defaultMessage="Categoría" /></span>
                                    <img src={(showFilterByCategories) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCategories(!showFilterByCategories) }} />
                                </div>

                                {(showFilterByCategories) && (

                                    <div className="options">

                                        {categoriesOptions.map((category) => (<label htmlFor={category.name} className='option'> <input type="checkbox" id={category.name} name="category" value={category.name} checked={categoryFilter.includes(category.id)} onChange={(event) => { handlerCategoryFilter(event, category.id) }} /> {(locale === 'es-CO') ? category.nombre : category.name}</label>))}

                                    </div>)}
                            </div>

                            <div className="filter" >
                                <div className="filterName">
                                    <span><FormattedMessage id="filter_title_4" defaultMessage="Precio" /></span>
                                    <img src={(showFilterByPrices) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByPrices(!showFilterByPrices) }} />
                                </div>

                                {(showFilterByPrices) && (

                                    <div className="options">

                                        {pricesOptions.map((price) => (<label htmlFor={price.range} className='option'> <input type="checkbox" id={price.range} name="category" value={price.range} checked={queryPriceId.includes(price.id)} onChange={(event) => { handlerPriceFilter(event, price) }} /> {(locale === 'es-CO') ? price.rango : price.range}</label>))}

                                    </div>)}
                            </div>

                            {/* <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="companies_menu_option_2" defaultMessage="# de seguidores" /></span>
                                    <img src={(showFilterByFollowers) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByFollowers(!showFilterByFollowers) }} />
                                </div>
                                {(showFilterByFollowers) && (<div className="options">

                                    {followerOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                                </div>)}
                            </div> */}

                            {/* <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="companies_menu_option_3" defaultMessage="# de colaboraciones" /></span>
                                    <img src={(showFilterByCollaborations) ? dropDownPinkUp : dropDownPink} alt="" onClick={() => { setShowFilterByCollaborations(!showFilterByCollaborations) }} />
                                </div>
                                {(showFilterByCollaborations) && (<div className="options">

                                    {collaborationsOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                                </div>)}
                            </div> */}

                            <div className="filter">
                                <div className="filterName">
                                    <p><FormattedMessage id="companies_menu_option_8" defaultMessage="Rango" /></p>
                                </div>
                                <Stack spacing={1}>
                                    <Rating name="size-large" /* defaultValue={2} */ size="large" precision={0.5} value={ratingFilter} onChange={(event, newValue) => {
                                        setRatingFilter(newValue);
                                        setOffset(0);
                                    }} />
                                </Stack>
                            </div>


                            <div className="filter">
                                <div className="filterName">
                                    <span onClick={() => {
                                        setFeaturedFilter(!featuredFilter)
                                        setOffset(0);
                                    }} className={featuredFilter && 'selected'}><FormattedMessage id="companies_menu_option_4" defaultMessage="Destacados" /></span>

                                </div>
                            </div>

                            <div className="filter">
                                <div className="filterName">
                                    <span onClick={() => {
                                        setNewUserFilter(!newUserFilter)
                                        setOffset(0);
                                    }} className={newUserFilter && 'selected'} ><FormattedMessage id="companies_menu_option_5" defaultMessage="Nuevos" /></span>

                                </div>
                            </div>

                            {/* <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="companies_menu_option_6" defaultMessage="Mis favoritos" /></span>

                                </div>
                            </div> */}

                            {/* <div className="filter">
                                <div className="filterName">
                                    <span><FormattedMessage id="companies_menu_option_7" defaultMessage="Mis me gusta" /></span>

                                </div>
                            </div> */}


                        </div>

                    )}

                </div>

                <div className="influencersContent">
                    <div className="results">
                        <p className="totalResults">{total} <FormattedMessage id="companies_text_1" defaultMessage="resultados" /></p>
                        <div className="orderBy" ref={orderByRef}>
                            <div className="orderByTitle">
                                <p>
                                    <FormattedMessage id="companies_text_2" defaultMessage="Ordenar por" />
                                </p>
                                <img src={(showOrderByMenu) ? dropDownPinkUp : dropDownPink} alt="order by" onClick={() => { setShowOrderByMenu(!showOrderByMenu) }} />
                            </div>

                            {(showOrderByMenu) && (<div className="menuOrderBy" >
                                <label htmlFor="name" className="option">
                                    <input type="radio" id="name" name="orderBy" value="name" checked={orderBy === 'name'} onChange={(event) => { handlerOrderBy(event) }} />
                                    <FormattedMessage id="companies_subtext_2_1" defaultMessage="Nombre" />
                                </label>
                                <label htmlFor="lowerRange" className="option">
                                    <input type="radio" id="lowerRange" name="orderBy" value="lowerRange" checked={orderBy === 'lowerRange'} onChange={(event) => { handlerOrderBy(event) }} />
                                    <FormattedMessage id="companies_subtext_2_2" defaultMessage="Menor rango" />
                                </label>
                                <label htmlFor="higherRange" className="option">
                                    <input type="radio" id="higherRange" name="orderBy" value="higherRange" checked={orderBy === 'higherRange'} onChange={(event) => { handlerOrderBy(event) }} />
                                    <FormattedMessage id="companies_subtext_2_3" defaultMessage="Mayor rango" />
                                </label>
                            </div>)}

                        </div>
                    </div>

                    <div className="cards">
                        {influencers?.map((influencer) => (
                            <InfluencerCard influencer={influencer} key={influencer.id} />
                        ))}

                    </div>

                    {(total === '0') && (<div className="noResults">
                        <p><FormattedMessage id="influncer_no_results" defaultMessage="No se han encontrado resultados" /></p>
                    </div>)}

                    {(limit + offset < total) && (<p className="seeMore" onClick={seeMore}><FormattedMessage id="companies_text_3" defaultMessage="Ver más +" /></p>)}

                </div>

            </div>
            {(isLoading) && (<Spinner />)}

        </InfluencersContainer>
    )
}